import { Link } from 'react-router-dom';
import { categories, categoryDescriptions } from '@/mocks/categories';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6 md:mb-8 text-center">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按类型浏览，快速找到你喜欢的韩国漫画
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-5">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-4 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer text-center"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`} />
              </div>
              <h3 className="mt-3 md:mt-4 text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}漫画
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
                {categoryDescriptions[cat.slug]}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}